import storage from "redux-persist/lib/storage";

const authPersistConfig  = {
    key: 'authReducer',
    storage: storage,
    blacklist: ['errorStatus'],
};

const renewPasswordPersistConfig  = {
    key: 'renewPassword',
    storage: storage,
    blacklist: ['error','isSend'],
};

export  const persistRules = {
    authPersistConfig,
    renewPasswordPersistConfig
}